import React from "react";
import StreakChartUI from "./components/streak-chart";
import {Box, Button, Paper, Stack, Typography} from "@mui/material";
import EditGoalDropdown from "./components/edit-goal-dropdown";

import {useDispatch} from "react-redux";
import {useGetProfileQuery} from "../../store/api/userApiSlice";
import {openLoginDialog} from "../../store/actions/loginDialogSlice";
import {AppDispatch} from "../../store/store";
import {
  useGetStreakQuery,
  useUpdateStreakGoalMutation,
} from "../../store/api/problemsetApiSlice";

export type StreakChartDataType = {
  date: string;
  score: number;
};
export default function DailyStreakChartMain() {
  const dispatch = useDispatch<AppDispatch>();

  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const {data: userData} = useGetProfileQuery();
  const {data: streakData} = useGetStreakQuery();
  const [updateStreakGoal] = useUpdateStreakGoalMutation();

  const handleEditClick = () => {
    if (!userData) {
      dispatch(openLoginDialog());
      return;
    }
    setIsDropdownOpen(true);
  };

  const handleApplyGoal = async (newGoal: number) => {
    try {
      await updateStreakGoal({streakGoal: newGoal});
      setIsDropdownOpen(false);
    } catch (err) {
      console.error("Failed to update goal", err);
    }
  };

  return (
    <Paper variant="feature" sx={{p: 3}}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography component="h6" variant="body1" fontWeight="bold">
          DAILY STREAK
        </Typography>
        <Button
          ref={anchorRef}
          onClick={handleEditClick}
          variant="text"
          size="small"
          sx={{
            p: 0,
            minWidth: 0,
            opacity: userData ? 1 : 0.5,
            color: "primary.contrastText",
          }}>
          Edit
        </Button>
      </Stack>
      <Box height={2} />
      <Typography component="p" variant="subtitle2" fontWeight="light">
        Stay consistent! Set daily goals & build streaks
      </Typography>
      <Box height={16} />
      <StreakChartUI
        chartData={streakData?.data}
        goal={streakData?.streakGoal ?? DEFAULT_STREAK_GOAL}
      />
      {userData && streakData && (
        <EditGoalDropdown
          anchorRef={anchorRef}
          isOpen={isDropdownOpen}
          onClose={() => setIsDropdownOpen(false)}
          currentGoal={streakData?.streakGoal}
          onApply={handleApplyGoal}
        />
      )}
    </Paper>
  );
}

const DEFAULT_STREAK_GOAL = 15; // Default goal if not set
